export default "__VITE_ASSET__9a79fa77__"